// import MarketButton from 'ui/market-button/market-button';
import { FEATURE_FLAG_LIST, useFeatureFlags } from 'hooks';
import { useAccount } from 'frontastic';
import styles from './top-nav-desktop-bar.module.scss';
import BusinessUnitName from '../business-unit-name';
import ShippingLocation from '../shipping-location';

export const TopNavDesktopBar = () => {
  const { hasCoordinatorRole } = useAccount();
  const { isFeatureEnabled } = useFeatureFlags();

  const showBusinessUnit = hasCoordinatorRole && isFeatureEnabled(FEATURE_FLAG_LIST.ORDER_ON_BEHALF_BU_SELECTION);

  return (
    <div className={styles.topNavDesktopBar}>
      {showBusinessUnit && <BusinessUnitName />}
      <ShippingLocation />
    </div>
  );
};
